import React from "react";

import {Link} from "react-router-dom";

import {makeStyles, Theme, createStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";

// import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import {Box} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    breadContainer: {},

    link: {
      display: "flex",
    },
    icon: {
      marginRight: theme.spacing(0.5),
      width: 20,
      height: 20,
    },
  })
);

function handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

type BreadCrumbsNavProps = {
  factory: string;
  project: string;
};

export default function BreadCrumbsNav({factory, project}: BreadCrumbsNavProps) {
  const classes = useStyles();

  return (
    <Breadcrumbs aria-label="breadcrumb" className={classes.breadContainer}>
      <Link color="inherit" to="/inspect" className={classes.link}>
        <HomeIcon className={classes.icon} />
        My Project
      </Link>
      <Typography color="textPrimary" className={classes.link}>
        {project}
      </Typography>
    </Breadcrumbs>
  );
}
